export default {
    yes: "Igen",
    no: "Nem"
}